// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mb-G","question":"styles_question__3SGp5","inputVisibleButton":"styles_inputVisibleButton__iGlfQ","note":"styles_note__1bes6"};